import Vue from 'vue'
import VueRouter from 'vue-router'
import config from 'SrcConfig'
import store from '@/store'

// layouts
const Layout = () => import('@/layout/index.vue')

// main views
const Login = () => import('@/pages/login.vue')
const ForgotPassword = () => import('@/pages/forgot-password.vue')
const Dashboard = () => import('@/pages/dashboard.vue')
const DestinationReport = () => import('@/pages/load/DestinationsList.vue')

// error views
const Error404 = () => import('@/pages/404.vue')

// routes
import loads from './load'
import account from './account'
import credentials from './credentials'

Vue.use(VueRouter)

const routes = [
  {
    name: 'root',
    path: '/',
    redirect: config.homeUrl,
    component: Layout,
    children: [
      {
        name: 'Login',
        path: 'login',
        component: Login,
        meta: { title: 'account.login', layout: 'content-only', public: true }
      },
      {
        name: 'Dashboard',
        path: config.homeUrl,
        component: Dashboard,
        meta: { title: 'nav.home', layout: 'dashboard' }
      },
      {
        name: 'DestinationReport',
        path: `${config.homeUrl}/destination-report`,
        component: DestinationReport,
        meta: { title: 'nav.destinationReport' }
      },
      loads,
      account,
      credentials
    ]
  },
  {
    name: 'catch-all',
    path: '*',
    component: Error404
  }
]

if (config.auth.forgotPasswordIsEnabled) {
  routes[0].children.push({
    name: 'ForgotPassword',
    path: 'forgot-password',
    meta: {
      title: 'account.forgotPassword',
      layout: 'content-only',
      public: true
    },
    component: ForgotPassword
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.public) {
    next()
  } else {
    if (store.getters.account) next()
    else
      next({
        name: 'Login',
        query: {
          redirect: !['/', config.homeUrl].includes(to.fullPath)
            ? to.fullPath
            : undefined
        }
      })
  }
})

export default router
